// AUDITUI.A3 (#2588) — the artefact history drawer.
//
// SlideOver hosting AuditTrail at entity scope. The drawer owns nothing about
// rendering an event: that is A2's component. It owns the panel, and the host
// (ArtefactProvenanceLine) owns the fetch.
//
// DELIBERATELY NOT HERE, by the rulings on #2588 (issuecomment-5830289535):
//   - no footer stating append-only or a retention period. Both are false on
//     main: admin.router.ts:187 and :216 delete audit rows, and no retention
//     clock exists. AC4 is superseded; A2 made the same call on 13 Sep and this
//     drawer does not contradict the component inside it.
//   - no expander. #2810 owns diff rendering, and A3 is the story that would
//     falsify #2848's premise that a tab stop per row is acceptable because
//     nothing expands yet.
//   - no "Open full trail" link. A5 does not exist; a visible control that does
//     nothing is worse than an absent one, and no AC asks for it.
//
// Focus restoration on close is SlideOver's, not this component's — see the
// comment at SlideOver.tsx's focus effect for why it lives in the shared
// component rather than in five copies.

import SlideOver from '../SlideOver';
import AuditTrail from './AuditTrail';
import type { AuditEvent } from './auditShared';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  /** Display title for the artefact whose history this is. */
  events: readonly AuditEvent[];
  loading?: boolean;
  error?: string | null;
  /** #3872 — passed through to AuditTrail's empty state. */
  emptyMessage?: string;
  /** Injectable clock, threaded to AuditTrail's rows. */
  now?: number;
}

export default function ArtefactHistoryDrawer({
  isOpen,
  onClose,
  events,
  loading = false,
  error = null,
  emptyMessage,
  now,
}: Props) {
  return (
    // The artefact title is NOT passed as SlideOver's subtitle. SlideOver stays
    // mounted while closed (it animates on a transform), so a subtitle would put
    // the artefact's name in the DOM a second time — which broke an existing
    // getByText assertion in ArtefactDetailContent.codereview.test.tsx. The
    // drawer is opened from the artefact being viewed, so the context is not in
    // doubt.
    <SlideOver isOpen={isOpen} onClose={onClose} title="History" width="md">
      <div data-testid="artefact-history-drawer" style={{ padding: '4px 20px 20px' }}>
        <AuditTrail events={events} loading={loading} error={error} emptyMessage={emptyMessage} now={now} />
      </div>
    </SlideOver>
  );
}
